import { render, staticRenderFns } from "./ContentBlockPartialTimecodes.vue?vue&type=template&id=8f894bea&scoped=true&"
import script from "./ContentBlockPartialTimecodes.vue?vue&type=script&lang=js&"
export * from "./ContentBlockPartialTimecodes.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlockPartialTimecodes.vue?vue&type=style&index=0&id=8f894bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f894bea",
  null
  
)

export default component.exports